<template>
  <span />
</template>

<script>
import XlsxMixin from "@/mixins/XlsxMixin.js";
import Catalog from "../ReceiveCatalog.js";
import Info from "../ReceiveInfo.js";

export default {
  mixins: [XlsxMixin],
  props: {
    items: Array
  },
  methods: {
    exportExcel() {
      this.createBook();
      this.createSheet();

      this.addList();
      this.download(Info.Export.List.Excel.FileName);
    },

    addList() {
      // label
      this.addSequenceHeader();
      this.addColumnHeader(Catalog.Date);
      this.addColumnHeader(Catalog.ReceiveNumber);
      this.addColumnHeader(Catalog.WarehouseName);
      this.addColumnHeader(Catalog.VendorID);
      this.addColumnHeader(Catalog.VendorAlias);
      this.addColumnHeader(Catalog.VendorName);
      this.addColumnHeader(Catalog.PurchasingNumber);
      this.addColumnHeader(Catalog.Total);

      // value
      for (const row of this.items) {
        this.addRow();

        this.addSequenceCell();
        this.addCellValue("Date", row, Catalog);
        this.addCellValue("ReceiveNumber", row, Catalog);
        this.addCellValue("WarehouseName", row, Catalog);
        this.addCellValue("VendorID", row, Catalog);
        this.addCellValue("VendorAlias", row, Catalog);
        this.addCellValue("VendorName", row, Catalog);
        this.addCellValue("PurchasingNumber", row, Catalog);
        this.addCellValue("Total", row, Catalog);
      }

      this.addSheet(Info.Export.List.Excel.SheetName.List);
    }
  },
}
</script>